<template>
<section class="latest-news" v-if="data.length">
    <div class="container">
        <z-caption
            class="u-bottom-margin--xl-important"
            v-if="showTitle"
            size="xl"
            tag="h2"
            :href="`/${this.$root.lang}/press-center/news/`"
            uppercase
            weight="900"
        >
            <span v-html="text.newsTitle"></span>
        </z-caption>
        <slider
            :space-between="48"
            last-empty
            slides-per-view="2.5"
            class="latest-news__slider"
        >
            <slide
                 v-for="(item, index) in data"
                 :key="index"
                 class="latest-news__slide"
             >
                <news-card :data="item"/>
            </slide>
            <!-- Последний пустой -->
            <slide
                class="latest-news__slide"
            >
            </slide>
        </slider>
    </div>
</section>
</template>

<script>
import { localize } from '@/utils/i18n'
import NewsCard from './components/NewsCard.vue'

export default {
    name: 'news',
    components: {
        NewsCard
    },
    props: {
        showTitle: {
            type: Boolean,
            default: true
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            text: {
                newsTitle: localize({
                    ru: 'Пресс-релизы и новости',
                    en: 'Press releases and news'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.latest-news {
    .swiper-container {
        overflow: visible;
    }
    &__slide {
        width: 40%;

        @include breakpoint (v-tablet) {
            width: 80%;
        }

        @include breakpoint (mobile) {
            width: 90%;
        }
    }

    &__slider {
        overflow: hidden;
        padding-bottom: 3em;

        @include breakpoint (laptop) {
            overflow: visible;
        }

        @include breakpoint(tablet) {
            padding-bottom: 1.1em;
        }

        .news-card__title {
            padding-right: 0 !important;
        }
    }

}
</style>
